import React from 'react';
import { Container } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <p className="mb-2">&copy; {new Date().getFullYear()} John West. All rights reserved.</p>
        <p className="mb-0 footer-links">
          <a href="/privacy">Privacy Policy</a>
          <span className="footer-sep" aria-hidden="true">·</span>
          <a href="/terms">Terms of Service</a>
        </p>
      </Container>
    </footer>
  );
}

export default Footer;
